const ROUTES = {
  CASE_STUDIES: "/case-studies",
};

export default ROUTES;
